import * as Yup from 'yup';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object().shape({
    isGroup: Yup.boolean().nullable().required('Please select an option'),
    users: Yup.array()
      .of(
        Yup.object().shape({
          firstName: Yup.string().required('Required'),
          lastName: Yup.string().required('Required'),
          phone: Yup.string().required('Please input your mobile phone number'),
          email: Yup.string().email('Invalid email').required('Required'),
        })
      )
      .required('Make sure you fill at least one admin.')
      .when('isGroup', {
        is: false,
        then: (f) => f.notRequired(),
      }),
  }),
});
